import { useSelector } from "react-redux";

import DatasetList from "@/components/dataset/datasetList";
import { RootState } from "@/store";

import { twMerge } from "tailwind-merge";

const noop = () => {};

/**
 * The map's layer panel: the same Data Selection card Spatial Analysis uses,
 * anchored to the top right of the conversation's map.
 *
 * Rendered only once something is on the map, since this page has no "Add
 * Dataset" button and so no empty state to show. It lists whatever the shared
 * `dataset` slice holds, which is exactly what the shared map is painting.
 *
 * Row actions are off: removing a layer here would leave a stale entry in
 * `useAgentWorkspaceAdapter`, the only record of what the agent put on the map.
 */
const AgenticAIDatasetPanel = ({
  isReportShortcutVisible = false
}: {
  isReportShortcutVisible?: boolean;
}) => {
  const visualizationOrder = useSelector(
    (state: RootState) => state.dataset.visualizationOrder
  );

  if (!visualizationOrder?.length) return null;

  return (
    <div
      data-testid="agentic-dataset-panel"
      className={twMerge(
        "absolute right-4 top-4 z-[9] flex max-h-[calc(100%-32px)] w-[338px] flex-col overflow-hidden rounded-lg border border-gainsboro bg-white",
        isReportShortcutVisible && "top-[78px] max-h-[calc(100%-94px)]"
      )}
    >
      <div className="custom-scrollbar flex flex-col overflow-y-auto px-4 py-3">
        <h2 className="font-sans text-sm font-semibold text-txtHeading">
          Data Selection
        </h2>
        <p className="font-sans text-[10px] text-txtBody">
          Customise how the agent&apos;s data appears on the map.
        </p>

        <DatasetList withRowActions={false} onOpenDatasetTabularModal={noop} />
      </div>
    </div>
  );
};

export default AgenticAIDatasetPanel;
